export default __webpack_public_path__ + "static/media/dogNotFound.1e520284.png";